var toastDom = null;
var toastText;
var isToast = false;
var lastTimer = null;
export var showToast = function (text, timeout) {
    if (timeout === void 0) { timeout = 1500; }
    if (!text)
        return;
    if (!toastDom) {
        toastDom = document.createElement('div');
        toastText = document.createElement('span');
        toastText.innerText = text;
        toastDom.appendChild(toastText);
        toastDom.setAttribute('style', "\n          position: fixed;\n          left: 50%;\n          bottom: 20%;\n          height: 40px;\n          padding: 0 18px;\n          border-radius: 6px;\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          background-color: #6b6b6b;\n          font-weight: 400;\n          font-size: 14px;\n          line-height: 18px;\n          color: #fff;\n          overflow: hidden;\n          white-space: nowrap;\n          z-index: 100000;\n          transform: translateX(-50%);\n          transition: all 0.4s ease-in-out;\n          opacity: 0;\n      ");
    }
    else {
        toastText.innerText = text;
    }
    // let clearTimer = null
    if (isToast) {
        // @ts-ignore
        toastDom === null || toastDom === void 0 ? void 0 : toastDom.style.opacity = 0;
        lastTimer && clearTimeout(lastTimer);
    }
    isToast = true;
    document.body.appendChild(toastDom);
    lastTimer = setTimeout(function () {
        // @ts-ignore
        toastDom === null || toastDom === void 0 ? void 0 : toastDom.style.opacity = 1;
        lastTimer = setTimeout(function () {
            // @ts-ignore
            toastDom === null || toastDom === void 0 ? void 0 : toastDom.style.opacity = 0;
            lastTimer = setTimeout(function () {
                toastDom === null || toastDom === void 0 ? void 0 : toastDom.remove();
            }, 400);
        }, timeout + 400);
    }, 0);
};
